import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=0f747f74&scoped=true"
import script from "./BillingSettings.vue?vue&type=script&lang=ts"
export * from "./BillingSettings.vue?vue&type=script&lang=ts"
import style0 from "./BillingSettings.vue?vue&type=style&index=0&id=0f747f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f747f74",
  null
  
)

export default component.exports